import React from 'react'
import { config } from 'config'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Helmet from 'react-helmet'
import { Container } from 'react-responsive-grid'
import { rhythm } from '../utils/typography'
import { Scrollspy } from 'react-scrollspy'
import VisibilitySensor from 'react-visibility-sensor'
import ThreejsBackdrop from 'components/ThreejsBackdrop'
import SkillsSection from 'components/SkillsSection'
import AwardsSection from 'components/AwardsSection'
import styles from './about.module.scss'
import profilePic from 'components/profile-pic.jpg'
import works from 'data/works'
import workCategories from 'data/work-categories'
import awards from 'data/awards'
import talks from 'data/talks'
import { TiArrowLeft } from 'react-icons/lib/ti'

export default class Index extends React.Component {
    
  constructor () {
    super();
    this.state = {
      isBrowser: false,
      showChart: false,
      shouldReanimateChart: false
    };
  }

  componentDidMount() {
    console.log('component did mount');
    this.setState({ isBrowser: true });
  }

  onScrollChange(visibility) {
    console.log('scrollchange');
    console.log(visibility);
    if(visibility){
      this.setState({ shouldReanimateChart: true });
    } else {
      this.setState({ shouldReanimateChart: false });
    }
  }


  renderScrollSpy() {
    return (
      <div className="scrollspy">
        <Scrollspy items={ ['section-bio', 'section-awards', 'section-skills', 'section-talks', 'section-leisure'] } currentClassName="is-current" offset={-250}>
          <li><a href="#section-bio">BIO</a></li>
          <li><a href="#section-awards">AWARDS</a></li>
          <li><a href="#section-skills">SKILLS</a></li>
          <li><a href="#section-talks">TALKS</a></li>
          <li><a href="#section-leisure">LEISURE</a></li>
        </Scrollspy>
      </div>
    );
  }

  render () {
    return (
      <div>
        <Helmet
          title={config.siteTitle}
          meta={[
            {"name": "description", "content": "Sample"},
            {"name": "keywords", "content": "sample, something"},
          ]}
        />
        <div className={styles.bioContainer}>
          <Container
              style={{
                maxWidth: 960,
              }}
            >

            <div className={styles.bio} id="section-bio">
              <div className="section">
                <div className="section-header section-header-malibu">
                  <Link to="/" className="section-header-link">
                    <TiArrowLeft className="icon-back"/>
                  </Link>
                  <h2>ABOUT</h2>
                </div>
                <p className={styles.bioContent}>
                Soravis is a user experience designer and full-stack developer based in Bangkok. His interest lies in Human-Computer Interaction, Assistive Technology and Mobile Computing.  
                For 5 years, he has been using modern web and mobile technology to craft meaningful <Link to="/works/">digital products</Link>. 
                </p>
                <br />
                <p>
                In 2014, he co-founded <a href="http://runnables.co.th" target="_blank">Runnables</a>, a young and vibrant application development studio focusing on web and mobile. 
                At Runnables, he collaborated with medical practitioners from King Chulalongkorn Memorial Hospital, Meditech Solution and Thai Government’s Office of SME Promotion to bring value to users. 
                Before that, he was a multimedia developer at Digimagic after 
                graduating with first-class honors majoring in Computer Engineering from Chulalongkorn University.
                </p>
              </div>

            </div>
          </Container>
        </div>
        <div className="section-container section-container-azure" 
              id="section-awards">
          
          <Container
              style={{
                maxWidth: 1170,
                paddingTop: 0,
                padding: `${rhythm(1)} ${rhythm(3/4)}`,
              }}
            >
            <div className="section">
              <div className="section-header section-header-white">
                <h2>Awards & Recognitions</h2>
              </div>
              <AwardsSection data={awards} type="awards"/>
            </div>
          </Container>
        </div>
        <div className="section-container section-container-robins-egg-blue" id="section-skills">
        {this.state.isBrowser &&
          <div className={styles.skillsContainer}> 
            <VisibilitySensor 
              onChange={(isVisible) => {this.onScrollChange(isVisible)}}
              className={styles.skillsVisibilitySensor}/>
            <SkillsSection shouldReanimate={this.state.shouldReanimateChart}/>
          </div>
        }
          <Container
                style={{
                  maxWidth: 960,
                }}
                className="section-footer"
              >
            
          </Container>
        </div>
        <div className="section-container section-container-malibu" 
              id="section-talks">
          
          <Container
              style={{
                maxWidth: 1170,
                paddingTop: 0,
                padding: `${rhythm(1)} ${rhythm(3/4)}`,
              }}
            >
            <div className="section">
              <div className="section-header section-header-white">
                <h2>Presentations & Talks</h2>
              </div>
              <AwardsSection data={talks} type="talks"/>
            </div>
          </Container>
        </div>
        <div className="section-container section-container-fuchsia-blue" 
              id="section-leisure">
          
          <Container
              style={{
                maxWidth: 1170,
                paddingTop: 0,
                padding: `${rhythm(1)} ${rhythm(3/4)}`,
              }}
            >
            <div className="section">
              <div className="section-header section-header-white">
                <h2>LEISURE</h2>
              </div>
              <div className="center">
                <p className="center">
                  When he is not working on projects, he enjoys playing multiple musical instruments.<br/> He mainly plays drums in local <a href="https://www.youtube.com/watch?v=dAqfpII5e9U" target="_blank">jam sessions</a> and <a href="https://www.youtube.com/watch?v=9Q1AULa3mQQ" target="_blank">gigs</a>.
                  He is currently teaching himself Musical Saw and has produced covers of <a href="https://www.youtube.com/watch?v=LYD0ByeQbvE" target="_blank">Solider's Poem by MUSE</a> and <a href="https://www.youtube.com/watch?v=Q1y4z9s9Bt4" target="_blank">The Moon Song.</a>
                </p>
                <img src={prefixLink(profilePic)} className={styles.leisurePic}/>
              </div>
            </div>
            <div className="section center">
              <Link to="/">← HOME</Link>
            </div>
          </Container>
        </div>
        {this.renderScrollSpy()}
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./about.js
 **/